<!--
 * @Description: 运单轨迹入口页面
 * @Author: l_hc
 * @LastEditors: Do not edit
 * @Date: 2019-06-17 16:31:07
 * @LastEditTime: 2019-08-16 11:24:52
 -->
<template>
  <div v-loading="loading" class="waybill-route">
    <div class="search-warp">
      <div class="search">
        <el-input
          v-model="params.tsOrderNum"
          :validate-event="true"
          :maxlength="20"
          placeholder="请输入订单编号查询"
          class="input-with-select"
        >
          <el-button slot="append" class="search-btn" icon="el-icon-search" @click="getData">搜索</el-button>
        </el-input>
        <div v-show="!active" class="no-data-info">
          <font>{{ initState? '请输入订单号 !':'暂无匹配数据' }}</font>
        </div>
      </div>
    </div>
    <template v-if="active">
      <div class="title">
        <el-row>
          <el-col :span="6 ">订单编号：{{ data.orderNum }}</el-col>
          <el-col :span="6">订单状态：{{ data.orderStatus }}</el-col>
          <el-col :span="6">起运地：{{ data.startPlace }}</el-col>
          <el-col :span="6">目的地：{{ data.stopPlace }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">承运方单位：{{ data.transportCompany }}</el-col>
          <el-col :span="6">货物名称：{{ data.goodsName }}</el-col>
          <el-col :span="6">货物重量：{{ data.weight }} 吨</el-col>
          <el-col :span="6">联系人：{{ data.transportPerson }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">联系电话：{{ data.transportTel }}</el-col>
        </el-row>
      </div>
      <div class="main-body">
        <div class="time-line">
          <Speed :data="data" />
        </div>
        <div class="map">
          <WayBillTrajectory :data="data" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getData } from '@/api/monitor/waybill-route'
// import { data } from './components/data'
import Speed from './components/Speed'
import WayBillTrajectory from './components/WayBillTrajectory'
import { mapGetters } from 'vuex'
export default {
  name: 'WaybillRoute',
  components: { Speed, WayBillTrajectory },
  computed: {
    ...mapGetters(['authStatus'])
  },
  data() {
    return {
      val: '',
      // data: data,
      data: {},
      params: { tsOrderNum: '' },
      loading: false,
      active: false,
      initState: true
    }
  },
  created: function() {},
  methods: {
    init() {
      this.getData()
    },
    // 搜索并判断是否认证
    getData() {
      if (this.authStatus == '2') {
        if (this.params.tsOrderNum && this.params.tsOrderNum !== '') {
          this.loading = true
          getData(this.params)
            .then(data => {
              if (data && data.result && data.result.id) {
                this.data = data.result
                if (!this.active) {
                  this.active = true
                }
              } else {
                this.$message({
                  message: '该订单不存在!',
                  type: 'error'
                })
                if (this.active) {
                  this.active = false
                }
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {
              this.loading = false
              if (this.initState) {
                this.initState = false
              }
            })
        } else {
          this.$message({
            message: '请填写订单号!',
            type: 'warning'
          })
          if (this.active) {
            this.active = false
          }
        }
      } else {
        this.$router.push({ name: 'QualificationsAuthen' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.waybill-route {
  width: 1200px;
  margin: 0 auto;
  .search-warp {
    background-color: #fff;
    width: 100%;
    margin-top: 16px;
    .search {
      width: 1200px;
      min-height: 82px;
      margin: 0 auto;
      padding-top: 18px;
      background: #fff;
      &-btn {
        background-color: $base-color;
        border-radius: 0px 4px 4px 0px;
        color: #fff;
        border: 1px solid $base-color;
      }
    }
  }
  .title {
    font-size: 16px;
    color: #333333;
    // padding: 0px 0px;
    margin-bottom: 32px;
    /deep/.el-row {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0px !important;
      }
    }
  }
  .main-body {
    display: flex;
    width: 100%;
    .time-line {
      position: relative;
      width: 300px;
      height: 704px;
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 5px;
      }
    }
    .map {
      width: calc(100% - 300px);
      height: 704px;
      margin-bottom: 50px;
    }
  }
}

.no-data-info {
  background-color: #fff;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
}
</style>
